module.exports = __webpack_public_path__ + "static/schedule-fd1ba6c09e61332b16208d7553531fe5.svg";